import type { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import {
  AuthenticationProvider,
  DatoContextProvider,
  MarketProvider
} from '@polestar/shared-front-myorder';
import type { ReactNode } from 'react';
import type { EnvConfig } from '~config';

/**
 * Implement all the different context provider here, they will be passed to the application
 */

type AppContextProviderProps = {
  config: EnvConfig;
  apolloClient?: ApolloClient<NormalizedCacheObject>;
  children: ReactNode;
};

const getFetchUserUrl = (config: EnvConfig) => {
  const { orderBack } = config.api;
  const hasTrailingSlash = orderBack?.endsWith('/');

  return (hasTrailingSlash ? orderBack : `${orderBack}/`) + 'currentUser';
};

export const AppContextProvider = ({ config, children }: AppContextProviderProps) => {
  const { global } = config.api;
  return (
    <DatoContextProvider>
      <MarketProvider>
        <AuthenticationProvider
          stage={config.stage}
          config={{
            fetchUserUrl: getFetchUserUrl(config),
            disableCognito: true,
            checkoutFetchUserUrl: global
          }}
        >
          {children}
        </AuthenticationProvider>
      </MarketProvider>
    </DatoContextProvider>
  );
};
